export const datePresetOptions = [
    { value: 'Today', label: 'Today' },
    { value: 'This week', label: 'This week' },
    { value: 'Next week', label: 'Next week' },
    { value: 'This month', label: 'This month' },
    { value: 'Next month', label: 'Next month' },
    { value: 'Custom', label: 'Custom' },
];
